export const FETCH_PRACTICE_INCOME_REQUEST = "FETCH_PRACTICE_INCOME_REQUEST";
export const FETCH_PRACTICE_INCOME_SUCCESS = "FETCH_PRACTICE_INCOME_SUCCESS";
export const FETCH_PRACTICE_INCOME_FAILURE = "FETCH_PRACTICE_INCOME_FAILURE";
